import { useLayoutContext } from "@context/layout";
import { EXPIRY_STATUS, IOrderPermanentCouponItem } from "@types";
import { handleCourseUrl } from "@utils/handleCourseUrl";
import { useState } from "react";
import UseCommonProfile from "./useCommonProfile";

interface ProfileLayoutConfig {
  defaultSelected?: string;
  revalidate?: boolean;
  withAdminHeader?: boolean;
}
export const useProfileLayout = ({
  defaultSelected,
  revalidate,
  withAdminHeader,
}: ProfileLayoutConfig) => {
  const {
    logout,
    selected,
    setSelected,
    permanentCoupon,
    showBanner,
    contentRef,
  } = UseCommonProfile(defaultSelected, revalidate);

  const { userData, isAdmin } = useLayoutContext();
  const marginContainer = withAdminHeader ? 106 : 56;
  const profileName =
    userData &&
    `${
      userData?.user?.first_name !== null && userData?.user?.first_name
        ? userData?.user.first_name
        : ""
    }  ${
      userData?.user?.last_name !== null && userData?.user?.last_name
        ? userData.user.last_name
        : ""
    }`;

  const item = permanentCoupon?.data?.find(
    (item: IOrderPermanentCouponItem) =>
      item.details_expire.expiry_status === EXPIRY_STATUS.EXPIRABLE &&
      item.details_expire.can_purchase
  );
  const product = item?.product?.[0];
  const expire = item?.details_expire;
  const courseCouponUrl = product
    ? handleCourseUrl(product?.type, product?.sku)
    : "";
  const [closeBanner, setCloseBanner] = useState(false);
  return {
    selected,
    setSelected,
    logout,
    profileName,
    userData,
    showBanner,
    isAdmin,
    expire,
    closeBanner,
    product,
    courseCouponUrl,
    marginContainer,
    contentRef,
    setCloseBanner,
  };
};
